import { render, staticRenderFns } from "./assignSiteDialog.vue?vue&type=template&id=dd2b6d0a&scoped=true"
import script from "./assignSiteDialog.vue?vue&type=script&lang=js"
export * from "./assignSiteDialog.vue?vue&type=script&lang=js"
import style0 from "./assignSiteDialog.vue?vue&type=style&index=0&id=dd2b6d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2b6d0a",
  null
  
)

export default component.exports